<template>
  <h3 class="root">
    NOT A RUX
  </h3>
</template>

<script>
export default {
  name: 'NotARUX'
}
</script>

<style>

</style>